export default "__VITE_ASSET__BeflPr5x__"